export default __webpack_public_path__ + "static/media/laura_davidson.9074cdb8.png";